import { PAY_PAL_MERCHANT_REGISTRATION_FAIL, PAY_PAL_MERCHANT_REGISTRATION_RECEIVE, PAY_PAL_MERCHANT_REGISTRATION_REQUEST } from '@engine/actions/action-types';
export var failPayPalMerchantRegistration = function failPayPalMerchantRegistration() {
  return {
    type: PAY_PAL_MERCHANT_REGISTRATION_FAIL
  };
};
export var responsePayPalMerchantRegistration = function responsePayPalMerchantRegistration(data) {
  return {
    type: PAY_PAL_MERCHANT_REGISTRATION_RECEIVE,
    data: data
  };
};
export var requestPayPalMerchantRegistration = function requestPayPalMerchantRegistration() {
  return {
    type: PAY_PAL_MERCHANT_REGISTRATION_REQUEST
  };
};
export function payPalMerchantRegistrationRequest(url, method) {
  return function (dispatch) {
    dispatch(requestPayPalMerchantRegistration());
    return fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: method,
      body: JSON.stringify({
        authenticity_token: window.CSRF
      })
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(responsePayPalMerchantRegistration(json));
    })["catch"](function () {
      return dispatch(failPayPalMerchantRegistration());
    });
  };
}